import React from "react";
import styles from "../NewsRoomSection/NewsRoomSection.module.css";
import newsData from "../../json/newsRoomData.json";

const NewsRoomSection = () => {
  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1>News</h1>

          {newsData.newsLinks.map((item) => (
            <div key={item.id} className={styles.LinkDiv}>
              <div className={styles.titleDiv}>
                <h3 className={styles.linkTitle}>{item.title}</h3>
              </div>
              <div className={styles.link}>
                <h5>
                  {/* <a
                    className={styles.ancorLink}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.linkText}
                  </a> */}
                  <a
  className={styles.ancorLink}
  href={item.url}
  {...(item.id !== 3 && {
    target: "_blank",
    rel: "noopener noreferrer",
  })}
>
  {item.linkText}
</a>
                  {item.date && <p className={styles.datediv}>{item.date}</p>}
                </h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsRoomSection;
